import { CuisineCategories, CuisineTypes, RestaurantTypes } from '../../../../../modals/company/Constants';
import { Step } from '../../../../../modals/company/add-company-modal';
import { LeadSources, PosSystems } from '../../../../../modals/company/add-company-modal/BusinessDetails';
import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Registrazione ristorante',
  description: 'Passo {{activeStep}} di {{totalSteps}}',
  steps: {
    [Step.BasicInfo]: 'Info base',
    [Step.BusinessDetails]: 'Dettagli aziendali',
  },
  form: {
    name: {
      label: 'Nome ristorante',
      placeholder: 'Inserisci nome ristorante',
    },
    timezone: {
      label: 'Fuso orario',
      placeholder: 'Cerca una città o un fuso orario',
      inference_failed: 'Impossibile determinare il fuso orario da questo indirizzo — selezionalo manualmente.',
    },
    google_place: {
      label: 'Luogo Google selezionato: {{name}}',
    },
    is_franchise: {
      label: 'Il ristorante fa parte di un marchio',
    },
    other_platforms: {
      label: 'Piattaforme di consegna attuali',
      description: 'Seleziona tutte le piattaforme su cui sei presente',
    },
    pos_system: {
      label: 'Sistema POS attuale',
      placeholder: 'Seleziona il tuo sistema POS',
      options: {
        [PosSystems.Other]: 'Altro',
      },
    },
    delivery_mode: {
      label: 'Modalità di consegna',
      placeholder: 'Seleziona modalità di consegna',
      options: {
        [DeliveryMode.Internal]: 'Interno (corrieri propri)',
        [DeliveryMode.External]: 'Esterno (terze parti)',
      },
    },
    monthly_sales_other_platforms: {
      label: 'Vendite consegna mensili',
      description: 'Vendite totali su tutte le piattaforme',
      placeholder: 'Seleziona fascia di vendita',
      options: {
        other: 'Altro',
      },
      other: {
        placeholder: 'Inserisci importo vendite',
      },
    },
    lead_source: {
      label: 'Fonte lead',
      description: 'Come ci hai conosciuto?',
      options: {
        [LeadSources.SDR]: {
          title: 'SDR',
          description: 'Contatto tramite Sales Development Representative',
        },
        [LeadSources.Inbound]: {
          title: 'Inbound',
          description: 'Arrivato tramite sito web o marketing',
        },
        [LeadSources.Referral]: {
          title: 'Referral - Ristorante esistente',
          description: 'Segnalato da un ristorante partner',
        },
        [LeadSources.SelfGeneratedCold]: {
          title: 'Autogestito - Cold',
          description: 'Trovato tramite contatto a freddo o prospecting',
        },
        [LeadSources.SelfGeneratedReferral]: {
          title: 'Autogestito - Referral',
          description: 'Rete o contatto personale',
        },
        [LeadSources.Tipster]: {
          title: 'Segnalatore',
          description: 'Foodamigos paga una commissione alla persona/azienda X per la segnalazione',
        },
      },
    },
    sdr: {
      description: "Seleziona l'SDR responsabile di questo lead",
    },
    has_instagram_profile: {
      label: 'Profilo Instagram',
      description: 'Il tuo ristorante ha un profilo Instagram?',
      options: {
        true: 'Sì',
        false: 'No',
      },
    },
  },
  buttons: {
    back: 'Indietro',
    next: 'Avanti',
    complete_registration: 'Completa registrazione',
  },
  basic_information: {
    title: 'Informazioni di base',
    description: 'Inserisci i dettagli base e le informazioni di contatto del ristorante',
  },
  restaurant_type: {
    title: 'Tipo di ristorante e modello di servizio',
    description: 'Scegli il formato che descrive meglio lo stile di servizio',
  },
  cuisine_type: {
    title: 'Categorie alimentari e tipi di cucina',
    description: 'Seleziona tutte le categorie e i tipi di cucina applicabili',
    placeholder: 'Cerca tipi di cucina',
  },
  business_details: {
    title: 'Dettagli aziendali',
    description: 'Aiutaci a capire le tue operazioni attuali',
  },
  restaurant_types: {
    [RestaurantTypes.FullServiceRestaurant]: {
      title: 'Ristorante a servizio completo',
      description: 'Ristorazione con servizio al tavolo',
    },
    [RestaurantTypes.FastCasual]: {
      title: 'Fast Casual',
      description: 'Ordine al bancone/app, qualità e personalizzazione superiori al QSR, posti opzionali',
    },
    [RestaurantTypes.QuickServiceTakeaway]: {
      title: 'Servizio rapido (QSR) / Asporto',
      description: 'Servizio al bancone veloce; principalmente asporto',
    },
    [RestaurantTypes.CafeAndBakery]: {
      title: 'Caffè e Panetteria',
      description: 'Caffè, pasticceria, piatti leggeri, colazione/brunch',
    },
    [RestaurantTypes.DessertAndIceCream]: {
      title: 'Dessert e Gelati',
      description: 'Concept orientati ai dolci',
    },
    [RestaurantTypes.DrinksAndBar]: {
      title: 'Bevande e Bar',
      description: 'Locali incentrati sulle bevande; cibo opzionale; consegna alcolici soggetta a normative locali',
    },
    [RestaurantTypes.DeliveryOnlyOrGhostKitchen]: {
      title: 'Solo consegna / Ghost Kitchen',
      description: 'Nessun negozio fisico; brand virtuali e cloud kitchen',
    },
  },
  cuisine_types: {
    [CuisineTypes.Pizza]: 'Pizza',
    [CuisineTypes.Burgers]: 'Hamburger',
    [CuisineTypes.ChickenFried]: 'Pollo fritto',
    [CuisineTypes.Wings]: 'Ali di pollo',
    [CuisineTypes.KebabDoner]: 'Kebab/Doner',
    [CuisineTypes.Sandwiches]: 'Panini',
    [CuisineTypes.Wraps]: 'Wraps',
    [CuisineTypes.Salads]: 'Insalate',
    [CuisineTypes.Healthy]: 'Salutare',
    [CuisineTypes.Bowls]: 'Bowl',
    [CuisineTypes.Vegan]: 'Vegano',
    [CuisineTypes.Vegetarian]: 'Vegetariano',
    [CuisineTypes.GlutenFree]: 'Senza glutine',
    [CuisineTypes.Halal]: 'Halal',

    [CuisineTypes.Sushi]: 'Sushi',
    [CuisineTypes.Japanese]: 'Giapponese',
    [CuisineTypes.Ramen]: 'Ramen',
    [CuisineTypes.UdonSoba]: 'Udon/Soba',
    [CuisineTypes.Korean]: 'Coreano',
    [CuisineTypes.KoreanFriedChicken]: 'Pollo fritto coreano',
    [CuisineTypes.Chinese]: 'Cinese',
    [CuisineTypes.Sichuan]: 'Sichuan',
    [CuisineTypes.CantoneseDimSum]: 'Cantonese/Dim Sum',
    [CuisineTypes.Thai]: 'Tailandese',
    [CuisineTypes.Vietnamese]: 'Vietnamita',
    [CuisineTypes.Malaysian]: 'Malese',
    [CuisineTypes.Indonesian]: 'Indonesiano',
    [CuisineTypes.Filipino]: 'Filippino',
    [CuisineTypes.Poke]: 'Poke',
    [CuisineTypes.HotPot]: 'Hot Pot',
    [CuisineTypes.DumplingsGyozaBao]: 'Dumplings/Gyoza/Bao',

    [CuisineTypes.Indian]: 'Indiana',
    [CuisineTypes.Biryani]: 'Biryani',
    [CuisineTypes.Pakistani]: 'Pakistana',
    [CuisineTypes.SriLankan]: 'Sri Lankese',
    [CuisineTypes.Nepalese]: 'Nepalese',

    [CuisineTypes.Turkish]: 'Turca',
    [CuisineTypes.Lebanese]: 'Libanese',
    [CuisineTypes.Syrian]: 'Siriana',
    [CuisineTypes.Israeli]: 'Israeliana',
    [CuisineTypes.Egyptian]: 'Egiziana',
    [CuisineTypes.PersianIranian]: 'Persiana/Iraniana',
    [CuisineTypes.Iraqi]: 'Irachena',
    [CuisineTypes.Afghan]: 'Afghana',
    [CuisineTypes.ShawarmaFalafel]: 'Shawarma/Falafel',
    [CuisineTypes.MezzeGrill]: 'Mezze/Grill',
    [CuisineTypes.Greek]: 'Greca',
    [CuisineTypes.Mediterranean]: 'Mediterranea',

    [CuisineTypes.Italian]: 'Italiana',
    [CuisineTypes.Pasta]: 'Pasta',
    [CuisineTypes.French]: 'Francese',
    [CuisineTypes.SpanishTapas]: 'Spagnola/Tapas',
    [CuisineTypes.Portuguese]: 'Portoghese',
    [CuisineTypes.German]: 'Tedesca',
    [CuisineTypes.Austrian]: 'Austriaca',
    [CuisineTypes.Balkan]: 'Balcanica',
    [CuisineTypes.Hungarian]: 'Ungherese',
    [CuisineTypes.Polish]: 'Polacca',
    [CuisineTypes.Czech]: 'Ceca',
    [CuisineTypes.Georgian]: 'Georgiana',

    [CuisineTypes.Mexican]: 'Messicana',
    [CuisineTypes.TexMex]: 'Tex-Mex',
    [CuisineTypes.Peruvian]: 'Peruviana',
    [CuisineTypes.Brazilian]: 'Brasiliana',
    [CuisineTypes.Argentinian]: 'Argentina',
    [CuisineTypes.Caribbean]: 'Caraibica',
    [CuisineTypes.BBQAmerican]: 'BBQ/Americana',
    [CuisineTypes.Steakhouse]: 'Steakhouse',
    [CuisineTypes.AmericanGeneral]: 'Americana (Generale)',
    [CuisineTypes.HotDogs]: 'Hot Dog',

    [CuisineTypes.Seafood]: 'Frutti di Mare',
    [CuisineTypes.FishAndChips]: 'Fish and Chips',
    [CuisineTypes.SteamedFish]: 'Pesce al Vapore',

    [CuisineTypes.BreakfastBrunch]: 'Colazione/Brunch',
    [CuisineTypes.Bagels]: 'Bagel',
    [CuisineTypes.Bakery]: 'Panetteria',
    [CuisineTypes.PastryDessert]: 'Pasticceria/Dessert',
    [CuisineTypes.WafflesCrepes]: 'Waffle/Crêpes',
    [CuisineTypes.IceCreamGelato]: 'Gelato',
    [CuisineTypes.Donuts]: 'Ciambelle',
    [CuisineTypes.Cakes]: 'Torte',

    [CuisineTypes.CoffeeCafe]: 'Caffè/Bar',
    [CuisineTypes.BubbleTea]: 'Bubble Tea',
    [CuisineTypes.JuiceSmoothies]: 'Succhi/Smoothie',
    [CuisineTypes.Milkshakes]: 'Milkshake',
    [CuisineTypes.BarPub]: 'Bar/Pub',
    [CuisineTypes.WineBar]: 'Wine Bar',
    [CuisineTypes.Cocktails]: 'Cocktail',

    [CuisineTypes.TapasMezeSmallPlates]: 'Tapas/Mezze/Piatti Piccoli',
    [CuisineTypes.Noodles]: 'Noodles',
    [CuisineTypes.Soup]: 'Zuppa',
    [CuisineTypes.Schnitzel]: 'Schnitzel',
    [CuisineTypes.SoulFood]: 'Soul Food',
    [CuisineTypes.ComfortFood]: 'Comfort Food',
    [CuisineTypes.StreetFood]: 'Street Food',
    [CuisineTypes.OrganicBio]: 'Biologico/Bio',
    [CuisineTypes.KidsMenu]: 'Menu Bambini',
  },
  cuisine_categories: {
    [CuisineCategories.TopGeneral]: 'Top/Generale',
    [CuisineCategories.AsianPacific]: 'Asia/Pacifico',
    [CuisineCategories.SouthAsian]: 'Asia del Sud',
    [CuisineCategories.MiddleEastMediterranean]: 'Medio Oriente/Mediterraneo',
    [CuisineCategories.Europe]: 'Europa',
    [CuisineCategories.Americas]: 'Americhe',
    [CuisineCategories.SeafoodSpecialty]: 'Specialità di Mare',
    [CuisineCategories.BreakfastBakerySweets]: 'Colazione/Pasticceria/Dolci',
    [CuisineCategories.BeverageLed]: 'Bevande',
    [CuisineCategories.OtherConcepts]: 'Altri Concetti',
  },
};
